/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ApplicableTaxType } from './';
import {
    ApplicableTaxTypeFromJSON,
    ApplicableTaxTypeFromJSONTyped,
    ApplicableTaxTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApplicableTax
 */
export interface ApplicableTax {
    /**
     * 
     * @type {ApplicableTaxType}
     * @memberof ApplicableTax
     */
    type?: ApplicableTaxType;
    /**
     * The tax value set in /freelancer/company/FREELANCER_COMPANY_ID/my-business-details
     * @type {number}
     * @memberof ApplicableTax
     */
    defaultPercent?: number;
    /**
     * The current select tax for the quote (default for unsaved draft quote)
     * @type {number}
     * @memberof ApplicableTax
     */
    selectedPercent?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApplicableTax
     */
    eligiblePercents?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ApplicableTax
     */
    editableRule?: ApplicableTaxEditableRuleEnum;
    /**
     * Replaced by editableRule
     * @type {boolean}
     * @memberof ApplicableTax
     * @deprecated
     */
    isExempted?: boolean;
}


/**
 * @export
 */
export const ApplicableTaxEditableRuleEnum = {
    Editable: 'EDITABLE',
    NotEditable: 'NOT_EDITABLE',
    CrossBorderNotEditable: 'CROSS_BORDER_NOT_EDITABLE',
    ExemptedNotEditable: 'EXEMPTED_NOT_EDITABLE'
} as const;
export type ApplicableTaxEditableRuleEnum = typeof ApplicableTaxEditableRuleEnum[keyof typeof ApplicableTaxEditableRuleEnum];


/**
 * Check if a given object implements the ApplicableTax interface.
 */
export function instanceOfApplicableTax(value: object): value is ApplicableTax {
    return true;
}

export function ApplicableTaxFromJSON(json: any): ApplicableTax {
    return ApplicableTaxFromJSONTyped(json, false);
}

export function ApplicableTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicableTax {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : ApplicableTaxTypeFromJSON(json['type']),
        'defaultPercent': json['defaultPercent'] == null ? undefined : json['defaultPercent'],
        'selectedPercent': json['selectedPercent'] == null ? undefined : json['selectedPercent'],
        'eligiblePercents': json['eligiblePercents'] == null ? undefined : json['eligiblePercents'],
        'editableRule': json['editableRule'] == null ? undefined : json['editableRule'],
        'isExempted': json['isExempted'] == null ? undefined : json['isExempted'],
    };
}

export function ApplicableTaxToJSON(value?: ApplicableTax | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': ApplicableTaxTypeToJSON(value['type']),
        'defaultPercent': value['defaultPercent'],
        'selectedPercent': value['selectedPercent'],
        'eligiblePercents': value['eligiblePercents'],
        'editableRule': value['editableRule'],
        'isExempted': value['isExempted'],
    };
}

